import { createContext } from 'react';

/** Embedding supplies hierarchy; a component's own title does not declare global importance. */
export const SurfaceHeadingLevel = createContext<1 | 2>(1);
